import { Form } from 'antd';
import { useContext } from 'react';

import { PictureList } from 'app/components/commons/ImageUploader/PictureList/PictureList';
import { PictureGallery } from 'app/components/commons/Package/Pictures/PictureGallery';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { Picture } from 'app/typings';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';
import { ExperienceType } from 'app/typings/experiences';

import { pictureToPictureView, pictureViewToPicture } from './utils';

const DEFAULT_KIND = 'sourcing';
const DEFAULT_PICTURES_CATEGORIES = [
  { name: 'Official', type: 'official' },
  { name: 'Sourcing', type: 'sourcing' },
];

export const CoverPicture = () => {
  const { mode } = useContext(ViewEditModeContext);

  const form = Form.useFormInstance();
  const picturesValues = Form.useWatch('coverPicture', form);
  const hotelId = Form.useWatch('hotelId', form);
  const experienceType = Form.useWatch('experienceType', form);

  const isOriginal = experienceType === ExperienceType.STAYCATION;
  const title = 'Add photos';

  return (
    <Form.Item
      name="coverPicture"
      valuePropName="value"
      getValueProps={(value: PictureView | PictureView[]) => {
        const picture = Array.isArray(value) ? value[0] : value;

        return {
          value: picture ? [pictureViewToPicture(picture)] : [],
        };
      }}
      getValueFromEvent={(pictures: Picture[]) =>
        pictures?.[0] ? pictureToPictureView(pictures[0]) : undefined
      }
    >
      {mode !== 'view' ? (
        <PictureGallery
          sectionTitle={title || 'Add photos'}
          hotelId={!isOriginal ? hotelId : undefined}
          picturesCategories={!isOriginal ? DEFAULT_PICTURES_CATEGORIES : []}
          kind={DEFAULT_KIND}
          previewable
          draggable
          editable
          removable
          maxPictures={1}
        />
      ) : picturesValues ? (
        <PictureList
          pictures={
            picturesValues ? [pictureViewToPicture(picturesValues)] : []
          }
          uploadingItems={{}}
          previewable
        />
      ) : (
        <span className="view-data">ø empty</span>
      )}
    </Form.Item>
  );
};
